import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import axios from "axios";
import toast from "react-hot-toast";

const isUserAuthenticated = () => {
  const accessTokenGoogle = localStorage.getItem('accessTokenGoogle');
  const departmentAccessToken = localStorage.getItem('departmentAccessToken');
  const clientAccessTokenGoogle = localStorage.getItem('clientAccessTokenGoogle');

  return !!(accessTokenGoogle || departmentAccessToken || clientAccessTokenGoogle);
};


function Faq() {
    const isAuthenticated = isUserAuthenticated();
  const [openQuestions, setOpenQuestions] = useState(new Set());
  const queryRef = useRef("");
  const [loading, setLoading] = useState(false);
  const [queryStatus, setQueryStatus] = useState("*For any queries please send to us");

  const faqs = [
    {
      id: 1,
      question: "What legal services are offered on this app?",
      answer:
        "Jurident facilitates access to a wide range of legal services, covering areas such as family law, criminal defense, business law, and more. The app connects you with experienced lawyers across various specialties to meet your specific needs.",
    },
    {
      id: 2,
      question: "How do I communicate with a lawyer on this app?",
      answer:
        "Communicating with a lawyer on Jurident is straightforward. Utilize the secure in-app messaging system to discuss your case, share documents, and receive timely updates. This ensures efficient and confidential communication between you and your legal professional.",
    },
    {
      id: 3,
      question: "How much does this app cost?",
      answer:
        "Jurident offers flexible pricing plans tailored to your legal requirements. The cost varies based on the complexity of services needed. You can find detailed pricing information on our website or within the app.",
    },
    {
      id: 4,
      question: "Is my information secure on this app?",
      answer:
        "Absolutely. Jurident prioritizes the security and confidentiality of your information. We employ advanced encryption and security measures to safeguard your data, ensuring a safe and protected environment for all users.",
    },
    {
      id: 5,
      question: "Can I use this app if I am outside the US?",
      answer:
        "Availability and scope of services vary by location, so please contact us to discuss your specific legal needs.",
    },
  ];

  const toggleQuestion = (id) => {
    const newOpenQuestions = new Set(openQuestions);
    if (newOpenQuestions.has(id)) {
      newOpenQuestions.delete(id);
    } else {
      newOpenQuestions.add(id);
    }
    setOpenQuestions(newOpenQuestions);
  };



  // send button handler
  const handleSent = () => {
    // Sending query to admin function
    const sendQuery = async () => {
      // getting the logged in user
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) {
        toast.error("not Logged In");
        return;
      }

      // Saving query
      const query = queryRef.current.value;
      console.log(query);

      // Getting the name for looged in user
      const userDocRef = doc(db, "lawyers", user.uid);
      const userDoc = await getDoc(userDocRef);
      if (!userDoc.exists()) {
        console.log("no such document");
        return;
      }
      // template for email
      const templateParam = {
        name: userDoc.data().name,
        email: user.email,
        phoneNumber: userDoc.data().mobileNumber,
        query: query,
      };

      try {
        setLoading(true); // Start loader
        await axios.post("https://juridentfeedbackmailbackend-4qnu.onrender.com/sendQuery", templateParam);
        setQueryStatus("Query Sent!")
        queryRef.current.value = "";
        setTimeout(() => {
          setQueryStatus("*For any queries please send to us"); // After 3-4 seconds, revert back
        }, 3000);
        console.log("QuerySent successfully")


      } catch (error) {
        console.log("error");
        toast.error("Failed to send query");
      }
      finally {
        setLoading(false);
      }


    }

    if (queryRef && queryRef.current.length !== 0) {
      sendQuery();
    }

  }

  return (
    <div className="min-h-screen text-white flex flex-col">
       {isAuthenticated && <Navbar />}
      <div className="background-circle circle-3 z-0"></div>
      <div className="background-circle circle-4 z-0"></div>
      <main className="px-4 md:px-16 py-8">
        <div className="relative bg-[#CDA454] py-4 mb-6">
          <Link
            to="/portal/Dashboard"
            className="absolute pl-4 md:pl-28 top-1/2 -translate-y-1/2"
          >
            <svg
              className="w-6 h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
          </Link>
          <h1 className="text-center font-semibold text-white md:text-2xl text-xl">
            Frequently Asked Questions (FAQs)
          </h1>
        </div>

        {/* FAQ Section */}
        <div className="container mx-auto px-6 py-8 max-w-3xl">
          {/* FAQ List */}
          <div className="space-y-4">
            {faqs.map((faq) => (
              <div
                key={faq.id}
                className="border border-gray-700 rounded-lg overflow-hidden"
              >
                <button
                  className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-white/5"
                  onClick={() => toggleQuestion(faq.id)}
                >
                  <span className="font-medium">{faq.question}</span>
                  <span className="text-2xl">
                    {openQuestions.has(faq.id) ? "−" : "+"}
                  </span>
                </button>

                {openQuestions.has(faq.id) && (
                  <div className="px-6 py-4 bg-white/5">
                    <p className="text-gray-300">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Query Input */}
          <div className="mt-12">
            <p className={`text-sm ${queryStatus === "Query Sent!" ? "text-green-500" : "text-gray-400"}  mb-4`}>
              {queryStatus}
            </p>
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="Write your query"
                className="flex-1 px-4 py-2 rounded-lg bg-white/5 border border-gray-700 focus:outline-none focus:border-[#CDA454]"
                ref={queryRef}
              />
              <button
                className="p-2 bg-[#CDA454] rounded-lg flex items-center justify-center w-12 h-12"
                onClick={handleSent}
                disabled={loading}
              >
                {loading ? (
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                    ></path>
                  </svg>
                ) : (
                  <svg
                    className="w-6 h-6 transform rotate-90"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11h2v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
                  </svg>
                )}
              </button>

            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Faq;